import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    countryCode: '',
    order: undefined,
    addresses: undefined,
    stores: [],
    shippingMethods: [],
    email: undefined,
    selectedShippingMethod: undefined,
    shippingAddress: undefined,
    activationAddress: undefined,
    packagingList: [],
    adyenPaymentMethodsResponse: undefined,
    adyenConfig: undefined,
    paymentError: undefined,
    stage: undefined,
    checkoutConfig: undefined,
    deliverydates: [],
    deliveryslots: [],
    nexiNonce: undefined,
    nexiSelectedPaymentMethod: undefined
};
export default createSlice({
    name: 'checkout',
    initialState: initialState,
    reducers: {
        updateCheckoutData: (state, action) => {
            var _a, _b, _c, _d, _e;
            let order = action.payload.order;
            if ((_a = order === null || order === void 0 ? void 0 : order.items) === null || _a === void 0 ? void 0 : _a.items) {
                order.items = order.items.items;
            }
            state.order = order;
            if ((order === null || order === void 0 ? void 0 : order.shipping) && (order === null || order === void 0 ? void 0 : order.shipping.length) > 0) {
                let shipping = order === null || order === void 0 ? void 0 : order.shipping[0];
                let activationAddress = shipping.activationAddress;
                state.selectedShippingMethod = shipping === null || shipping === void 0 ? void 0 : shipping.selectedShippingMethod;
                state.shippingAddress = shipping === null || shipping === void 0 ? void 0 : shipping.shippingAddress;
                state.shippingMethods = shipping === null || shipping === void 0 ? void 0 : shipping.applicableShippingMethods;
                state.deliverydates = shipping === null || shipping === void 0 ? void 0 : shipping.deliverydates;
                state.deliveryslots = shipping === null || shipping === void 0 ? void 0 : shipping.deliveryslots;
                if (activationAddress) {
                    state.activationAddress = {
                        activationAddressId: activationAddress.addressId,
                        activationFirstName: activationAddress.firstName,
                        activationLastName: activationAddress.lastName,
                        activationAddress1: activationAddress.address1,
                        activationCivic: activationAddress.civic,
                        activationCity: activationAddress.city,
                        activationStateCode: activationAddress.stateCode,
                        activationPostalCode: activationAddress.postalCode,
                        activationPhone: activationAddress.phone,
                        activationCountry: activationAddress.countryCode.value,
                        activationAdditionalInfo: activationAddress.additionalInfo
                    };
                }
                else {
                    state.activationAddress = undefined;
                }
            }
            else {
                state.shippingAddress = undefined;
                state.activationAddress = undefined;
            }
            state.customer = action.payload.customer;
            state.email = action.payload.email;
            if ((_c = (_b = action.payload.customer) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.email) {
                state.email = (_e = (_d = action.payload.customer) === null || _d === void 0 ? void 0 : _d.profile) === null || _e === void 0 ? void 0 : _e.email;
            }
            else if (order === null || order === void 0 ? void 0 : order.orderEmail) {
                state.email = order.orderEmail;
            }
            state.adyenConfig = action.payload.adyenConfig;
            state.checkoutConfig = action.payload.checkoutConfig;
            state.packagingList = action.payload.packagingList;
            if ((order === null || order === void 0 ? void 0 : order.billing) && (order === null || order === void 0 ? void 0 : order.billing.payment) && (order === null || order === void 0 ? void 0 : order.billing.payment.nexiPaymentMethod)) {
                state.nexiSelectedPaymentMethod = order === null || order === void 0 ? void 0 : order.billing.payment.nexiPaymentMethod;
            }
            else {
                state.nexiSelectedPaymentMethod = undefined;
            }
        },
        updateOrder: (state, action) => {
            var _a;
            let order = action.payload;
            if ((_a = order === null || order === void 0 ? void 0 : order.items) === null || _a === void 0 ? void 0 : _a.items) {
                order.items = order.items.items;
            }
            state.order = order;
            if ((order === null || order === void 0 ? void 0 : order.shipping) && (order === null || order === void 0 ? void 0 : order.shipping.length) > 0) {
                let shipping = order === null || order === void 0 ? void 0 : order.shipping[0];
                state.selectedShippingMethod = shipping === null || shipping === void 0 ? void 0 : shipping.selectedShippingMethod;
                state.shippingAddress = shipping === null || shipping === void 0 ? void 0 : shipping.shippingAddress;
                state.shippingMethods = shipping === null || shipping === void 0 ? void 0 : shipping.applicableShippingMethods;
                state.deliveryslots = shipping === null || shipping === void 0 ? void 0 : shipping.deliveryslots;
                state.deliverydates = shipping === null || shipping === void 0 ? void 0 : shipping.deliverydates;
                let activationAddress = shipping.activationAddress;
                if (activationAddress) {
                    state.activationAddress = {
                        activationAddressId: activationAddress.addressId,
                        activationFirstName: activationAddress.firstName,
                        activationLastName: activationAddress.lastName,
                        activationAddress1: activationAddress.address1,
                        activationCivic: activationAddress.civic,
                        activationCity: activationAddress.city,
                        activationStateCode: activationAddress.stateCode,
                        activationPostalCode: activationAddress.postalCode,
                        activationPhone: activationAddress.phone,
                        activationAdditionalInfo: activationAddress.additionalInfo
                    };
                }
                else {
                    state.activationAddress = undefined;
                }
            }
            else {
                state.shippingAddress = undefined;
            }
            if ((order === null || order === void 0 ? void 0 : order.billing) && (order === null || order === void 0 ? void 0 : order.billing.payment) && (order === null || order === void 0 ? void 0 : order.billing.payment.nexiPaymentMethod)) {
                state.nexiSelectedPaymentMethod = order === null || order === void 0 ? void 0 : order.billing.payment.nexiPaymentMethod;
            }
            else {
                state.nexiSelectedPaymentMethod = undefined;
            }
        },
        updateAddresses: (state, action) => {
            state.addresses = action.payload;
        },
        updatePaymentMethods: (state, action) => {
            state.adyenPaymentMethodsResponse = action.payload;
        },
        updateShippingMethods: (state, action) => {
            state.shippingMethods = action.payload;
        },
        updateCustomer: (state, action) => {
            state.customer = action.payload;
        },
        updateEmail: (state, action) => {
            state.email = action.payload;
        },
        updatePaymentError: (state, action) => {
            state.paymentError = action.payload;
        },
        updatePickupData: (state, action) => {
            state.stores = action.payload || [];
        },
        updateCountryCode: (state, action) => {
            state.countryCode = action.payload;
        },
        updateNexiNonce: (state, action) => {
            state.nexiNonce = action.payload;
        },
        updatePaymentMethod: (state, action) => {
            state.nexiSelectedPaymentMethod = action.payload;
        },
        updateActivationAddress: (state, action) => {
            state.activationAddress = action.payload;
        }
    },
});
